<template>
  <!-- <el-container>
    <el-container>
      <el-main>
        <div class="content">
          {{ "增加keep-alive缓存机制" }}
          <router-view></router-view>
        </div>
      </el-main>
    </el-container>
  </el-container> -->
  <div class="publicMain" ref="publicMain">
    <div class="leftClass" :style="mainStyle" id="leftClassId" ref="leftClass">
      <dragger :diy="true" :maxColumn="30" :minWidth="5" :minHeight="6" ref="dragger" :editable=false>
        <dragger-item :ref="'mychart'+item.option.componentId" :padding="'7px'" v-for="(item, index) in echartArr"
          :key="index" :item="item.option" class="boxChart">
          <!-- chart图形 -->
          <template v-if="item.option.chartType.type != 'table'">
            <div :id="'mychart'+item.zjid" style="width: 95%; height: 90%;" class="myChartClass"></div>
          </template>
          <!-- 表格 -->
          <template v-if="item.option.chartType.type == 'table'">
            <div class="myTableClass" :id="'myTable'+item.option.componentId" style="width: 95%;">
              <el-table :data="item.option.data.tableData" :border="true"
                :max-height="item.option.data.hasOwnProperty('tableStyle')?item.option.data.tableStyle.height:tableHeight"
                v-loading="item.option.componentId==propsCurrentId?tableLoading:false"
        :element-loading-text="$t('elTable.loadingText')" 
        element-loading-spinner="el-icon-loading">
                <el-table-column v-for="tItem in item.option.data.tableColumns" :label="item.fieldName"
                  :key="tItem.fieldName" :prop="tItem.fieldName" min-width="150px">
                  <div slot="header">
                    <el-row style="height: 100%;">
                      <span>
                        <svg-icon :icon-class="getDataIcon(tItem)" class="iconStyle"></svg-icon>
                      </span>
                      <span class="headerStyle">{{tItem.fieldName}}</span>
                    </el-row>
                  </div>
                  <template slot-scope="scope">
                    <span v-if="$comUtils.getFieldType(tItem) === 1">{{$comUtils.moneyFormat(scope.row[tItem.fieldName])}}</span>
                    <span v-else>{{scope.row[tItem.fieldName]}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </dragger-item>
      </dragger>
    </div>
  </div>
</template>

<script>

export default {
  name: 'externalVisit',
  components: {},
  provide () {
    return {
      reload: this.reload
    }
  },
  computed: {
    mainStyle () {
      return {
        'min-height': this.screenHeight - 22 + 'px',
        'width': '100%',
      }
    },
  },
  watch: {},
  data() {
    return {
      themeColor: 'light',// 主题色系macarons /// 全局背景dark/ light macarons
      screenHeight: '0', // 可视高度
      mbid: '', // 面板id
      // echart数组
      echartArr: [],
      // 父组件传递的数据
      propsCurrentId: '',
      chartLoading: false,
      tableData: [],
      tableColumns: [],
      tableHeight: "260",
      tableLoading: false
    };
  },
  methods:{
    // 获取url 参数
    getUrlKey(name) {
      return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
    },
    /** 数据检视字段图标 */
    getDataIcon: function (item) {
      switch (this.$comUtils.getFieldType(item)) {
        case '1':
          return 'number';
        case '2':
          return 'datetime';
        case '3':
          return 'string';
      }
      return '';
    },
    // 初始化图形
    initCharts () {
      this.echartArr.forEach((item, index) => {
        if (item.option.chartType.type == 'table') {
          return
        } else {
          this.$nextTick(() => {
            let chart = this.$echarts.init(document.getElementById(`mychart${item.zjid}`), this.themeColor); // 全局背景dark/ light macarons
            this.setOptions(chart, item.option.data);
          })
        }
      });
    },
    // 图形数据
    setOptions (c, data) {
      c.setOption(data)
    },
    // 获取当前编辑储存后的接口数据
    async getChart () {
      this.chartLoading = true
      this.echartArr = []
      try {
        let res = await this.$ajax.post(`/api/zjgl/queryList`, {
          mbid: this.mbid
        })
        this.chartLoading = false
        // console.log("get接口结果", res.data.data)
        let obj = {}
        this.echartArr = []

        res.data.data.forEach((item, index) => {
          this.echartArr.push(item)
        })
        // 筛选table表格数据
        let ttableData = res.data.data.filter(item => {
          if (item.option.chartType.type == 'table') {
            // debugger
            return item
          }
        })
        // 赋值表格数据
        // debugger
        if (ttableData.length > 0) {
          this.tableData = ttableData[0].option.data.tableData
          this.tableColumns = ttableData[0].option.data.tableColumns
        }
      } catch (err) {
        console.error('queryList接口异常', err)
      }
    },
    // 临时用户伪登录
    async forgeLogin(userId) {
      let _this = this;
      let params = {
        username: userId,
        password: "123456"
      }
      await _this.$ajax.post("/api/login", _this.$qs.stringify(params)).then(async (res) => {
        if(res.data.code == '200') {
          let userInfo = res.data.data;
          // 将用户token保存到vuex中
          _this.$store.commit('setToken', userInfo.token);
          // 获取登陆用户信息
          await _this.$requestUtil.getUserInfo({suid: userInfo.suid}).then(tmpResult => {
            _this.$store.commit('setUserInfo', tmpResult);
          });
        } else {
          _this.$message.error("链接已过期");
        }
      }).catch((error) => {
        _this.$message.error(_this.$t('resultCodeInfo.999'));
      });
    },
    // 根据用户ID获取模板ID
    async getMbidByYhid(userId) {
      let _this = this;
      await _this.$ajax.post("/api/mbgl/getMbidByYhid", _this.$qs.stringify({param: userId})).then((res) => {
        if(res.data.code == '200') {
          _this.mbid = res.data.data
        } else {
          _this.$message.error("未取到模板信息");
        }
      }).catch((error) => {
        _this.$message.error(_this.$t('resultCodeInfo.999'));
      });
    }
  },
  // 关闭页面的同时销毁页面
  deactivated() {
    this.$destroy('externalVisit')
  },
  async created() {
    // let _this = this
    // let yhid = _this.getUrlKey('suid')
    // if (window.performance.navigation.type !== 1) {
    //   // 首次打开链接是需要登录（伪登录）
    //   await _this.forgeLogin(yhid)
    // }
    // await _this.getMbidByYhid(yhid);
    // await _this.getChart();
    // await _this.$nextTick(async () => {
    //   await _this.initCharts();
    // })
  },
  mounted() {
    let _this = this
    _this.screenHeight = document.body.clientHeight;
    // window.onresize = () => {
    //   return (() => {
    //     _this.screenHeight = document.body.clientHeight;
    //   })();
    // };
  },
}

</script>

<style lang="scss" scoped>
.el-container {
  width: 100%;
  height: 100%;
}
.el-main {
  background-color: #f9f9f9;
  // border-top: 1px solid #f2f2f2;
  padding: 0;
}
.publicMain {
  overflow-y: hidden;
  padding: 10px 5px;
  background-color: #eceaef;
  .leftClass {
    float: left;
    overflow-x: hidden;
    // 顶部
    .header {
      height: 40px;
      position: absolute;
      top: 130px;
      right: 10px;
      z-index: 99999;
    }
    // 整体图形创建编辑的区域
    .boxChart {
      width: 100%;
      height: 100%;
      box-shadow: 0 0 1px 1px transparent;
      .myTableClass {
        .iconStyle {
          width: 24px;
          height: 24px;
          margin-right: 10px;
          display: inline-block;
          vertical-align: middle;
        }
        .headerStyle {
          display: inline-block;
          vertical-align: -2.3px;
        }
      }
    }
  }
}
// 右边栏
::v-deep .leftClass .right-tab {
  top: 100px !important;
  right: 0;
}

//  设置draggerItem的样式
::v-deep .componentContent {
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
